import React from 'react'
import type { PortalProviderProps } from './PortalProvider.types'

export const PortalContext = React.createContext<
  HTMLElement | ShadowRoot | undefined
>(undefined)

export function PortalProvider({ children, container }: PortalProviderProps) {
  return (
    <PortalContext.Provider value={container}>
      {children}
    </PortalContext.Provider>
  )
}

export function usePortalContainer(): HTMLElement | ShadowRoot | undefined {
  const container = React.useContext(PortalContext)
  return container
}
